import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUtilModule } from '@enauka/shared/util';
import { NgbDateAdapter, NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { DirectivesModule } from './directives/directives.module';
import { NgbDateStringAdapter } from './ngb-date-string-adapter';
import { NgbTimeStringAdapter } from './ngb-time-string-adapter';
import { PipesModule } from './pipes/pipes.module';
import { ToggleModule } from './toggle/toggle.module';
import { LocalStorageModule } from './local-storage/local-storage.module';



declare const $: any;

@NgModule({
  imports: [
    CommonModule,
    BreadcrumbModule,
    SharedUtilModule,
    DirectivesModule,
    PipesModule,
    ToggleModule,
    LocalStorageModule,
  ],
  declarations: [
  ],
  exports: [
    CommonModule,
    BreadcrumbModule,
    SharedUtilModule,
    DirectivesModule,
    PipesModule,
    ToggleModule
  ],
  providers: [
    CookieService,
    { provide: NgbDateAdapter, useClass: NgbDateStringAdapter },
    { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter }
  ]
})
export class SharedUiModule {

}
